export default "/assets/images/dark-moss-sm.1bb7c67b6e94f4bf.webp";